if( ! document.getElementById("employee-account-detail") ) {
    return;
}

const validatePassword = (password) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,20}$/;
    return regex.test(password);
};

const validateEmail = (email) => {
    return String(email)
    .toLowerCase()
    .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};
    
const confirmUpdate = document.querySelector('.custom-message-modal-btn.confirm');
const confirmBtnCancel = document.querySelector('.custom-message-modal-btn.btn-delete.cancel');
confirmUpdate.style.display = 'none';
confirmBtnCancel.style.display = 'none';
const modalCross = document.querySelector('.custom-message-modal-close');
const modalElement = document.querySelector('.custom-message-modal-overlay');

// const modal = document.querySelector('.custom-message-modal-overlay');
// if (modal) {
//     modal.addEventListener('click', function(e) { 
//         if (e.target.classList.contains('updated') || e.target.classList.contains('account-detail')) {
//             modal.classList.remove('d-flex');
//             e.target.remove();
//         }
//     });
// }

function employeeAccountDetailModal(message, title='Attention Required') {
    const modalTitle = document.querySelector('.custom-message-modal-title');
    const modalFooter = document.querySelector('.custom-message-modal-footer');
    const confirmButton = document.createElement('button');
    confirmButton.className = 'custom-message-modal-btn btn btn-primary btn-xs account-detail';
    confirmButton.textContent = 'Ok';

    if( modalElement ) modalElement.classList.add('processing');
    if( modalCross ) modalCross.style.display = 'none';

    if (modalTitle) modalTitle.innerHTML = title;
    if (modalFooter) {
        modalFooter.appendChild(confirmButton);
    }

    const modalMessage = document.querySelector('.custom-message-modal-body');
    if (modalMessage) {
        modalMessage.innerHTML = message;
    }

    const modalTriggerBtn = document.querySelector('.open-modal-btn');
    if (modalTriggerBtn) {
        modalTriggerBtn.click();
    }
}

const employeeAccountDetail = document.getElementById("employee-account-detail");
employeeAccountDetail.addEventListener("submit", function(event) {
    event.preventDefault();
    let passwordChange = false;
    let nameChange = false;
    
    const errorElements = document.querySelectorAll('.err');
    if(errorElements) errorElements.forEach(el => el.remove());

    if(document.querySelector('.custom-message-modal-btn.updated')) {
        document.querySelector('.custom-message-modal-btn.updated').remove();
    }

    const currentPassword = document.getElementById("current-password").value.trim();
    const newPassword = document.getElementById("new-password").value.trim();
    const confirmPassword = document.getElementById("confirm-password").value.trim();

    if (currentPassword || newPassword || confirmPassword) {
        if (!currentPassword || !newPassword || !confirmPassword) {
            // employeeAccountDetailModal("<p>If you are attempting to change password, all password fields are required.</p>");
            
            const p = document.createElement('p');
            p.className = 'err';
            p.textContent = 'If you are attempting to change password, all password fields are required.';
            document.getElementById("current-password").after(p);
            document.querySelector('#email').scrollIntoView({ behavior: 'smooth' });
            return;
        }

        if( ! validatePassword(newPassword) ) {
            // employeeAccountDetailModal('<p>Password must be at least 8-20 characters and include uppercase, lowercase, number, and special character</p>');
            
            const p = document.createElement('p');
            p.className = 'err';
            p.textContent = 'Password must be at least 8-20 characters, uppercase, lowercase, number, and special character';
            document.getElementById("new-password").after(p);
            document.querySelector('#email').scrollIntoView({ behavior: 'smooth' });
            return;
        }

        if( newPassword !== confirmPassword ) {
            // employeeAccountDetailModal("<p>Confirm password did not matched</p>");
            
            const p = document.createElement('p');
            p.className = 'err';
            p.textContent = 'Confirm password did not matched';
            document.getElementById("confirm-password").after(p);
            document.querySelector('#email').scrollIntoView({ behavior: 'smooth' });
            return;
        }
        passwordChange = true;
    }

    const firstName = document.getElementById("first-name").value.trim();
    const lastName = document.getElementById("last-name").value.trim();
    const contactNumber = document.getElementById("contactNumber").value.trim();
    const contactPreference = document.getElementById("contact-preference").value.trim();
    
    const sellerEmail = document.getElementById("seller-email").value.trim();

    const oldFirstName = document.getElementById("first-name").getAttribute('data-firstname').trim(); 
    const oldLastName = document.getElementById("last-name").getAttribute('data-lastname').trim(); 
    const oldContactNumber = document.getElementById("contactNumber").getAttribute('data-contactnumber').trim();

    const profileFileInput = document.getElementById("profile-image-upload");
   	const profileFile = profileFileInput.files[0];
    if (profileFile) {
		const maxSize = 5 * 1024 * 1024; // 5MB in bytes
        if (profileFile.size > maxSize) {
            employeeAccountDetailModal("<p>File size exceeds 5MB. Please upload a smaller file.</p>");
            document.querySelector('.dashboard--profile').scrollIntoView({ behavior: 'smooth' });
            
            const p = document.createElement('p');
            p.className = 'err';
            p.textContent = 'File size exceeds 5MB. Please upload a smaller file';
            profileFileInput.after(p);

            return;
        }
    }

    nameChange = (firstName !== oldFirstName) || (lastName !== oldLastName) || (contactNumber !== oldContactNumber);

    const errors = [];

    if (firstName === '') {
        errors.push({ message: 'First name is required', scrollDiv: '.pages-employee-account_detail', attrId: 'first-name' });
    } else {
        const nameRegex = /^[a-zA-Z\s]{2,50}$/;
        if (!nameRegex.test(firstName)) {
            errors.push({ message: 'First name must include alphabets of 2-50 characters', scrollDiv: '.pages-employee-account_detail', attrId: 'first-name' });
        }
    }
    if (lastName === '') {
        errors.push({ message: 'Last name is required', scrollDiv: '.pages-employee-account_detail', attrId: 'last-name' });
    } else {
        const nameRegex = /^[a-zA-Z\s]{2,50}$/;
        if (!nameRegex.test(lastName)) {
            errors.push({ message: 'Last name must include alphabets of 2-50 characters', scrollDiv: '.pages-employee-account_detail', attrId: 'last-name' });
        }
    }
    if (sellerEmail === '') {
        errors.push({ message: 'Seller email is required', scrollDiv: '.pages-employee-account_detail', attrId: 'seller-email' });
    } else {
        if(!validateEmail(sellerEmail)) {
            errors.push({ message: 'Enter valid email', scrollDiv: '.pages-employee-account_detail', attrId: 'seller-email' });

        }
    }

    if( (contactPreference == 'phone') && (contactNumber == '') ) {
        errors.push({ message: 'Contact phone is required for contact preference', scrollDiv: '#first-name', attrId: 'contactNumber' });
    }

    if (contactNumber === '') {
        // errors.push({ message: 'Contact number is required', scrollDiv: '#first-name', attrId: 'contactNumber' });
    } else if (!/^\d{10}$/.test(contactNumber)) {
        errors.push({ message: 'Please enter a valid 10-digit phone number', scrollDiv: '#first-name', attrId: 'contactNumber' });
    }

    if (errors.length > 0) {
        errors.forEach(error => {
            const errID = document.getElementById(error.attrId);
            const errMessage = error.message;
            if (errID) {
                const p = document.createElement('p');
                p.className = 'err';
                p.textContent = errMessage;

                if (error.attrId === 'contactNumber') {
                    const formElement = errID.closest('.form-element');
                    if (formElement) {
                        formElement.appendChild(p);
                    } else {
                        // fallback if .form-element not found
                        errID.after(p);
                    }
                } else {
                    errID.after(p);
                }
            }
        });

        // employeeAccountDetailModal('<p>Please fill in all necessary details to proceed.</p>');
        
        const target = document.querySelector(errors[0].scrollDiv);
        if (target) target.scrollIntoView({ behavior: 'smooth' });
        return;
    }

    const formData = new FormData(employeeAccountDetail); 
    formData.append('profile_image', profileFile);

    formData.append('nameChange', nameChange);
    formData.append('passwordChange', passwordChange);
    formData.append('action', 'employer_employee_account_detail');
    formData.append('nonce', ajax_callback_data.ajax_nonce);

    employeeAccountDetailModal('<p>Applying account update...</p>', 'Please wait');
    document.querySelector('.custom-message-modal-footer').innerHTML = '';

	fetch(ajax_callback_data.ajax_url, {
        method: 'POST',
        body: formData,
    })
    .then(response => response.json())
    .then(data => {
        if( data.success ) {
            employeeAccountDetailModal(data.data.message, 'Confirmation');
            document.querySelector('.custom-message-modal-footer').innerHTML = '';
            document.querySelector('.dashboard--profile').scrollIntoView({ behavior: 'smooth' });
            window.location.reload();

        } else {
            if( data.data.type && (data.data.type=='password') ) {
                const p = document.createElement('p');
                p.className = 'err';
                p.textContent = data.data.message;
                document.getElementById("current-password").after(p);
                document.querySelector('#email').scrollIntoView({ behavior: 'smooth' });
                if( modalCross ) modalCross.click();
                
            } else {
                employeeAccountDetailModal(`<p>${data.data.message}</p>`);
                if( modalCross ) modalCross.style.display = 'block';
            }
        }
    })
    .catch(error => {
        console.error('Error:', error);
        if( modalElement ) modalElement.classList.remove('processing');
        employeeAccountDetailModal('Something went wrong. Try again.');
    });
});